import { isWebApp, setServerUrl } from '../store/api/CommonFunctions';
import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getfirebaseToken } from './../firebase';
import { useHistory } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import { Button, Card, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { Key, Person, ShieldLock } from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
const company = localStorage.getItem("Company");

const Login = (props) => {
  const dispatch = useDispatch();
  let dialogData = {
    status: 'show',
    arrayBtn: ['ok'],
    dialogTitle: '',
    dialogText: ' '
  };
  const setErrorDialog = (message, title) => {

    dialogData.dialogTitle = title;
    if (message === "RelatedAgencyIsInBlackList") {
      dialogData.dialogText = "نمایندگی مرتبط با این کاربر در لیست سیاه قرار دارد";
    }
    else if (message === "UserIsNotActive") {
      dialogData.dialogText = "کاربر فعال نیست";
    }
    else if (message === "UserIsNotRelatedToStaff") {
      dialogData.dialogText = "کاربری که با آن وارد می شوید باید به یک نماینده/تکنسین متصل باشد";
    }
    else if (message === "UserHasNoValidRole") {
      dialogData.dialogText = "کاربری که با آن وارد می شوید باید دست کم یکی از نقش های تکنسین، نماینده یا پذیرش را داشته باشد";
    }
    else if (message === "NotFound") {
      dialogData.dialogText = "کاربری با این مشخصات در سیستم وجود ندارد";
    }
    else if (message === "ConnectionError") {
      dialogData.dialogText = "اشکال در ارتباط با سرور";
    }
    else if (message === "success") {
      dialogData.dialogText = "عملیات با موفقیت انجام شد";
    }
    else {
      dialogData.dialogText = message;
    }
    dispatch({
      type: "SET_DIALOG",
      data: dialogData
    });
  }
  const url = "api/accountapi/LoginAPI?username={username}&password={password}";
  useEffect(() => {
    document.body.classList = "notMain";
  }, []);
  const [isLoading, setLoading] = useState(false);
  function getResult(url, data) {
    fetch('././config.json'
      , {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        localStorage.setItem("ServerUrl", myJson.SERVER_URL);
        setServerUrl(myJson.SERVER_URL);
        return myJson.SERVER_URL;
      }).then(function (serverUrl) {
        fetch(serverUrl + url, {
          method: 'get',
          //redirect: 'follow',
          cache: "no-cache",
          headers: {
            "Content-Type": "application/json",
            "Data-Type": "JSON"
          }
        }).then(res => res.json())
          .then(resp => {
            setLoading(false);
            if (!resp) {
              return;
            }
            if (!resp.status && resp.Message === "Error") {
              setErrorDialog("ConnectionError", "ورود به سیستم");
              return;
            }
            if (resp.status === 404) {
              setErrorDialog("NotFound", "ورود به سیستم");
              return;
            }
            if (resp === "UserHasNoValidRole" || resp === "RelatedAgencyIsInBlackList" || resp === "UserIsNotActive" ||
              resp === "UserIsNotRelatedToStaff") {
              setErrorDialog(resp, "ورود به سیستم");
              return;
            }
            localStorage.setItem('token', resp);
            getfirebaseToken(serverUrl, resp);
            fetch(serverUrl + "api/Accountapi/GetUserRoleList", {
              headers: { "Token": resp, "Content-Type": "application/json", "Data-Type": "JSON" },
              method: "GET",
              cache: "no-cache"
            }).then(res => res.json())
              .then(res => {
                if (!res.Message) {
                  localStorage.setItem("RoleList", JSON.stringify(res.RoleList));
                  localStorage.setItem("UserInfo", JSON.stringify(res.UserInfo));
                }
              })
              .then(()=>{
            if (data.CompanyCode && data.CompanyCode !== "") {
              fetch("https://Demo.bpro.ir/CompanyAPI/GetCompany?RegisterCode=" + data.CompanyCode,
                { method: "GET", cache: "no-cache" })
                .then(res => res.json())
                .then(res => {
                  // if (res?.WebSite !== serverUrl) {
                  //   resp = null;
                  //   setErrorDialog("کد اکتیو معتبر نیست", "ورود به سیستم");
                  // }
                  //else {
                    localStorage.setItem("Company", JSON.stringify(res));
                    props.setUser(resp);
                  //}
                }
                )
                .catch(er => console.log("[GetCompany]", er))
            }
            else {
              props.setUser(resp);
            }})
          }).catch(err => {
            setLoading(false);
            setErrorDialog("NotFound", "ورود به سیستم");
            console.log("Login:", err);
          });
      })

  }


  function onSubmit(data) {

    const userUrl = url.replace('{username}', data.UserName).replace('{password}', data.Password);
    setLoading(true);
    getResult(userUrl, { username: data.UserName, Password: data.Password, CompanyCode: data.CompanyCode });

  }
  const { register, handleSubmit, errors } = useForm();
  return (
    <Fragment>
      <div className='logingPageLogoContainer'>
        <img src={company?.CompanyLogo} className='loginPageLogo' />
      </div>
      <div className="container justify-content-center d-flex loginContainer">
        {isLoading && <Loader type="BallTriangle" color="#bb1370" height={100} width={100} />}
        {!isLoading &&
          <Card className="flex-grow-1" style={{ margin: "auto", padding: 0 }}>
            <Card.Header className="headerStyle loginHeader">
              <h4 style={{ display: "inline-block" }}><FontAwesomeIcon icon={faDoorOpen} /> ورود به سامانه </h4>
            </Card.Header>
            <Card.Body className="bodyStyle  d-flex">
              <div style={{ flexGrow: 2 }} className='loginInfo'>
                <div className='loginTitle'>
                  <span></span>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {!company &&
                    <div className="form-group">
                      <div>
                        <label className='form-control' style={{ width: "50px", display: "inline-block", padding: "2.7px", textAlign: "center", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                          <ShieldLock size={29} />
                        </label>
                        <Form.Control name="CompanyCode" placeholder='کد اکتیو' ref={register({ required: true })} style={{ display: "inline-block", width: "calc(100% - 50px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                      </div>
                      {errors.UserName && <small className="errors"> کد اکتیو اجباری است </small>}
                    </div>
                  }
                  <div className="form-group">
                    <div>
                      <label className='form-control' style={{ width: "50px", display: "inline-block", padding: "2.7px", textAlign: "center", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                        <Person size={29} />
                      </label>
                      <Form.Control name="UserName" placeholder='نام کاربری' ref={register({ required: true })} style={{ display: "inline-block", width: "calc(100% - 50px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                    </div>
                    {errors.UserName && <small className="errors"> نام کاربری اجباری است </small>}
                  </div>
                  <br />
                  <div className="form-group mt-0">
                    <div>
                      <label className='form-control' style={{ width: "50px", display: "inline-block", textAlign: "center", padding: "2.7px", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
                        <Key size={29} />
                      </label>
                      <Form.Control name="Password" placeholder='رمز عبور' type="password" ref={register({ required: true })} style={{ display: "inline-block", width: "calc(100% - 50px)", borderTopRightRadius: 0, borderBottomRightRadius: 0 }} />
                    </div>
                    {errors.Password && <small className="errors"> رمز عبور را وارد کنید</small>}
                  </div>
                  <br />
                  <Button type="submit" className="w-100">ورود به سیستم</Button>
                </form>
              </div>
              {isWebApp() &&
                <Col md={9} className='loginImageContainer'>
                  <img src={process.env.PUBLIC_URL + "/images/LoginImage.png"} className='loginImage' />
                </Col>
              }
            </Card.Body>
            {/* <div className="row">
          <button className="btn btn-block w-100" style={{ color: 'red' }} onClick={() => { props.setForgetPassword(true); history.push("/ForgetPassword") }}>فراموشی رمز عبور</button>
        </div> */}
          </Card>
        }
      </div >
    </Fragment >)
}

export default Login;